import { render } from "./MaterialsByDay.vue?vue&type=template&id=7dbc5b84"
import script from "./MaterialsByDay.vue?vue&type=script&lang=js"
export * from "./MaterialsByDay.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Keith\\Dropbox\\WebStorm\\Projects\\slumbernot\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__